define("calendar/components/calendar/settings", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Portal @destinationElement="root-portal">
    <Shared::Modal @close={{@closeModal}} @focusTrap={{true}} as |modal|>
      <modal.card class="has--footer qa--calendar_settings_modal">
        <modal.card-header @title={{t "calendar.settings.title"}} data-test-id="calendar-settings-title" />
  
        <modal.card-body>
          <Calendar::Settings::TimeZone />
  
          {{#if this.displayBttpSettings}}
            <Calendar::Settings::Bttp
              @bttpReport={{this.bttpReport}}
              @bttpToggledOn={{this.bttpToggledOn}}
              @closeModal={{@closeModal}}
              @toggleBttp={{this.toggleBttp}}
            />
          {{/if}}
  
          <Calendar::Settings::Notes
            @closeSettingsModal={{@closeModal}}
            @showCalendarNotes={{@showCalendarNotes}}
            @toggleCalendarNotes={{@toggleCalendarNotes}}
          />
  
          <Calendar::Settings::Stories />
        </modal.card-body>
  
        <modal.card-footer>
          <div class="o--btnBar u--float--right">
            <Shared::Ui::Button
              @onClick={{@closeModal}}
              @text={{t "shared_words.close"}}
              @variant="outline"
              class="qa--cal_settings_close_btn"
            />
          </div>
        </modal.card-footer>
      </modal.card>
    </Shared::Modal>
  </Shared::Portal>
  */
  {
    "id": "jpa3EWbC",
    "block": "[[[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card\"]],[[24,0,\"has--footer qa--calendar_settings_modal\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[30,2,[\"card-header\"]],[[24,\"data-test-id\",\"calendar-settings-title\"]],[[\"@title\"],[[28,[37,2],[\"calendar.settings.title\"],null]]],null],[1,\"\\n\\n      \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,3],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"displayBttpSettings\"]],[[[1,\"          \"],[8,[39,5],null,[[\"@bttpReport\",\"@bttpToggledOn\",\"@closeModal\",\"@toggleBttp\"],[[30,0,[\"bttpReport\"]],[30,0,[\"bttpToggledOn\"]],[30,1],[30,0,[\"toggleBttp\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[8,[39,6],null,[[\"@closeSettingsModal\",\"@showCalendarNotes\",\"@toggleCalendarNotes\"],[[30,1],[30,3],[30,4]]],null],[1,\"\\n\\n        \"],[8,[39,7],null,null,null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n          \"],[8,[39,8],[[24,0,\"qa--cal_settings_close_btn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,2],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"]],[]]]]]],[\"@closeModal\",\"modal\",\"@showCalendarNotes\",\"@toggleCalendarNotes\"],false,[\"shared/portal\",\"shared/modal\",\"t\",\"calendar/settings/time-zone\",\"if\",\"calendar/settings/bttp\",\"calendar/settings/notes\",\"calendar/settings/stories\",\"shared/ui/button\"]]",
    "moduleName": "calendar/components/calendar/settings.hbs",
    "isStrictMode": false
  });
  let SettingsComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class SettingsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "bttp", _descriptor2, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor3, this);
    }
    get bttpReport() {
      return this.bttp.report;
    }
    get bttpToggledOn() {
      return this.bttp.toggledOn;
    }
    set bttpToggledOn(value) {
      this.bttp.setBttpToggle(value);
    }
    get displayBttpSettings() {
      return !this.selectedSocialProfiles.hasMultipleSelected && this.bttp.isValidSocialProfile;
    }
    get showFutureTrendsOnCalendar() {
      return this.auth.currentAccount?.rolloutFutureInsightsOnCalendar;
    }
    toggleBttp() {
      this.bttp.toggleBttp();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "toggleBttp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleBttp"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SettingsComponent);
});